import {Base,Axios} from "@/api/Base"

export class MpfDownMpfReport extends Base {

    path = "mpf/downMpfReport"
    download(param = {}) {
        return Axios.get(this.path, { params: param,responseType: "blob" })
    }
}